<template>
<div class="page-content">

    <SeoMeta 
        title="TheJobTap.com - Contact Us " 
        description="We’re here to help. Whether you're looking for more information, need assistance, or want to share feedback, feel free to reach out."
    />

<section class="pt-28 lg:pt-44 pb-28 group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 dark:bg-neutral-900 bg-[url('../images/home/page-title.png')] bg-center bg-cover relative" >
    <div class="container mx-auto">
        <div class="grid">
            <div class="col-span-12">
                <div class="text-center text-white">
                    <h1 class="mb-4 text-[26px]">Contact us</h1>
                    <div class="page-next">
                      <p>We’re here to help. Whether you're looking for more information, need assistance, or want to share feedback, feel free to reach out. <br/>Use the form below or send us a message. We will get back to you as soon as possible.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <img rel="prefetch" src="@/assets/images/about/shape.png" alt="header image" class="absolute block bg-cover -bottom-0 dark:hidden" style="width: 100%;">
    <img rel="prefetch" src="@/assets/images/about/shape-dark.png" alt="header image dark" class="absolute hidden bg-cover -bottom-0 dark:block" style="width: 100%;">
</section>

<!-- Start grid -->
    <section class="pt-16 py-20">
        <div class="container mx-auto">
            <div class="grid items-center grid-cols-12 mt-5 lg:gap-8 gap-y-8">
                <div class="col-span-12 lg:col-span-6">
                    <div class="mt-4  ">
                        <h3 class="mb-2 text-3xl text-gray-900 dark:text-white mb-4">Get in touch</h3>
                        <p class="text-gray-500 dark:text-gray-300 mb-4">If you've got a question, a comment, a proposal or anything else, we'd love to hear from you. You can get in touch by filling out the form below or contacting us at help@thejobtap.com</p>
                        <ContactUsForm class="contact-form mt-8" />
                    </div>
                </div><!--end col-->
                <div class="col-span-12 lg:col-span-5 lg:ml-20 mt-8">
                    <div class="text-center">
                        <img src="https://imagedelivery.net/EWJlSj3VmuhdddwuuB6Q0A/eac34639-09e8-4183-efb3-d929eeeac800/public" alt="contact us" class="img-fluid rounded">
                    </div>
                    <div class="pt-3 mt-4">
                        <!-- <div class="flex items-center mt-2 text-gray-500">
                            <div class="group-data-[theme-color=violet]:text-violet-500 group-data-[theme-color=sky]:text-sky-500 group-data-[theme-color=red]:text-red-500 group-data-[theme-color=green]:text-green-500 group-data-[theme-color=pink]:text-pink-500 group-data-[theme-color=blue]:text-blue-500 shrink-0 text-22">
                                <i class="uil uil-map-marker"></i>
                            </div>
                            <div class="ltr:ml-2 rtl:mr-2 grow-1">
                                <p class="mb-0 dark:text-gray-300">2453 Clinton StreetLittle Rock, California, USA</p>
                            </div>
                        </div> -->
                        <div class="flex items-center mt-2 text-gray-500">
                            <div class="group-data-[theme-color=violet]:text-violet-500 group-data-[theme-color=blue]:text-blue-500 shrink-0 text-22">
                                <i class="uil uil-envelope"></i>
                            </div>
                            <div class="ltr:ml-2 rtl:mr-2 grow-1">
                                <p class="mb-0 dark:text-gray-300">help@thejobtap.com</p>
                            </div>
                        </div>
                        <!-- <div class="flex items-center mt-2 text-gray-500">
                            <div class="group-data-[theme-color=violet]:text-violet-500 group-data-[theme-color=sky]:text-sky-500 group-data-[theme-color=red]:text-red-500 group-data-[theme-color=green]:text-green-500 group-data-[theme-color=pink]:text-pink-500 group-data-[theme-color=blue]:text-blue-500 shrink-0 text-22">
                                <i class="uil uil-phone-alt"></i>
                            </div>
                            <div class="ltr:ml-2 rtl:mr-2 grow-1">
                                <p class="mb-0 dark:text-gray-300">(+245) 223 1245</p>
                            </div>
                        </div> -->
                    </div>
                </div>
                <!--end col-->
            </div>
        </div>
    </section>
  </div>
</template>

<script>

import ContactUsForm from "@/components/Forms/ContactUsForm.vue";
import SeoMeta from "@/components/Seo/SeoMeta.vue";

export default {  
  name: "ContactUsView",
  components : {
    ContactUsForm, SeoMeta
  }, 
  mounted() {
    document.title = 'Contact - TheJobTap.com'
  }
};
</script>